import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, isRef as _isRef } from "vue";
const _hoisted_1 = {
  class: "dialog-footer"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("确认");

import { computed, ref, watch } from 'vue';
import { addressRecognition } from '@/request';
export default {
  name: 'EditGeneralAurveyInfoModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    currentData: {
      type: [Object, null],
      default: null
    },
    custTypeList: {
      type: Array,
      default: () => []
    },
    areaTreeData: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const form = ref({
      custName: '',
      linkMan: '',
      linkPhone: '',
      custType: '',
      custAddressCode: '',
      address: ''
    });
    const formRef = ref(); // watch(
    //   () => props.currentData,
    //   (newVal, oldVal) => {
    //     if (newVal && newVal !== oldVal) {
    //       form.value = {
    //         ...newVal,
    //         custAreaCode:
    //           newVal.custAreaCode || newVal.custCityCode || newVal.custProvinceCode
    //       };
    //     } else if (!newVal) {
    //       form.value = {
    //         custName: '',
    //         linkMan: '',
    //         linkPhone: '',
    //         custType: '',
    //         custAreaCode: '',
    //         address: ''
    //       };
    //     }
    //     formRef.value?.resetFields();
    //   }
    // );

    watch(() => props.modelValue, newVal => {
      if (!newVal) {
        var _formRef$value;

        // 清除效验信息
        form.value = {
          custName: '',
          linkMan: '',
          linkPhone: '',
          custType: '',
          custAddressCode: '',
          address: ''
        };
        (_formRef$value = formRef.value) === null || _formRef$value === void 0 ? void 0 : _formRef$value.resetFields();
      } else if (newVal && props.currentData) {
        form.value = _objectSpread(_objectSpread({}, props.currentData), {}, {
          custAddressCode: props.currentData.custAreaCode || props.currentData.custCityCode || props.currentData.custProvinceCode
        });
        elTreeData.value = props.areaTreeData;
        console.log(form.value);
      }
    });

    function checkLinkMan(rule, val, cb) {
      if (val && val.length > 20) {
        cb(new Error('联系人名称长度不可超过20'));
        return;
      }

      cb();
    }

    function checkLinkPhone(rule, val, cb) {
      if (val && !/^[0-9]{11}$/.test(val)) {
        cb(new Error('联系电话格式不正确'));
        return;
      }

      cb();
    }

    function changeArea(e) {
      let parent = e;
      form.value = _objectSpread(_objectSpread({}, form.value), {}, {
        custProvinceName: '',
        custProvinceCode: '',
        custCityName: '',
        custCityCode: '',
        custAreaName: '',
        custAreaCode: ''
      });

      while (parent) {
        let areaLevel = parent.areaLevel.replace(/^[a-z]/, i => i.toLocaleUpperCase());
        areaLevel = areaLevel === 'District' ? 'Area' : areaLevel;
        form.value['cust' + areaLevel + 'Code'] = parent.id;
        form.value['cust' + areaLevel + 'Name'] = parent.text;
        parent = parent.parent;
      }
    }

    function confirm() {
      formRef.value.validate((result, error) => {
        if (!error) {
          emit('success', _objectSpread(_objectSpread({}, form.value), {}, {
            custTypeName: props.custTypeList.find(i => i.dictitemCode === form.value.custType).dictitemName
          }));
        }
      });
    }

    const addreddLoading = ref(false);
    const municipality = ['北京市', '天津市', '上海市', '重庆市'];
    const elTreeData = ref([]);

    function addressRecognitionHandle() {
      addreddLoading.value = true;
      let body = {
        text: form.value.address
      };
      addressRecognition(body).then(res => {
        let {
          success,
          data
        } = res;
        if (!success) return;
        let targetObj = props.areaTreeData.find(item => item.text == data.province);

        if (data.city) {
          if (municipality.find(v => v === data.city) == undefined) {
            targetObj = targetObj.children.find(item => item.text == data.city);
          }

          if (data.county) {
            targetObj = targetObj.children.find(item => item.text == data.county);
          }
        }

        form.value.custAddressCode = targetObj.id;
        changeArea(targetObj);
      }).finally(() => addreddLoading.value = false);
    }

    function elTreeSelectFocus(e) {
      if (e === true) {
        elTreeData.value = [];
        setTimeout(() => elTreeData.value = props.areaTreeData, 0);
      }
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_tree_select = _resolveComponent("el-tree-select");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createBlock(_component_el_dialog, {
        "destroy-on-close": "",
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _isRef(visible) ? visible.value = $event : null),
        title: (__props.currentData ? '编辑' : '添加') + '普查客户',
        width: "800px"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createVNode(_component_el_button, {
          onClick: _cache[6] || (_cache[6] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })])]),
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_form, {
          model: form.value,
          ref_key: "formRef",
          ref: formRef
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "custName",
            label: "客户名称:",
            rules: [{
              required: true,
              message: '客户名称不可为空'
            }, {
              max: 50,
              message: '客户名称长度不可超过50'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.custName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.custName = $event),
              placeholder: "请输入客户名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_row, {
            gutter: 10
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                prop: "linkMan",
                label: "联系人:",
                rules: {
                  validator: checkLinkMan,
                  trigger: 'blur'
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.linkMan,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.linkMan = $event),
                  placeholder: "请输入联系人"
                }, null, 8, ["modelValue"])]),
                _: 1
              }, 8, ["rules"])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                prop: "linkPhone",
                label: "联系电话:",
                rules: {
                  validator: checkLinkPhone,
                  trigger: 'blur'
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.linkPhone,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.linkPhone = $event),
                  placeholder: "请输入联系电话"
                }, null, 8, ["modelValue"])]),
                _: 1
              }, 8, ["rules"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            gutter: 10
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                prop: "custType",
                label: "客户类型:",
                rules: {
                  required: true,
                  message: '客户类型不可为空'
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: form.value.custType,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.custType = $event)
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.custTypeList, type => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      label: type.dictitemName,
                      value: type.dictitemCode,
                      key: type.dictitemCode
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                prop: "custAddressCode",
                label: "客户区域:",
                rules: {
                  required: true,
                  message: '客户区域不可为空'
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_tree_select, {
                  modelValue: form.value.custAddressCode,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.custAddressCode = $event),
                  data: __props.areaTreeData,
                  label: "text",
                  "node-key": "id",
                  filterable: "",
                  accordion: "",
                  props: {
                    label: 'text'
                  },
                  "check-strictly": true,
                  onNodeClick: changeArea
                }, null, 8, ["modelValue", "data"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            prop: "address",
            label: "客户地址:",
            rules: [{
              required: true,
              message: '客户地址不可为空'
            }, {
              max: 100,
              message: '客户地址长度不可超过100'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.address,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.address = $event),
              placeholder: "请输入客户地址",
              onBlur: addressRecognitionHandle
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])), [[_directive_loading, addreddLoading.value]])]),
        _: 1
      }, 8, ["modelValue", "title"]);
    };
  }

};